import { useEffect, useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { IGetDepositLimitsResponseData } from 'js/hooks/socket/hooks/useGetDepositLimits/types';
import { ISetDepositLimitsRequestData } from 'js/hooks/socket/hooks/useSetDepositLimits/types';

/**
 * Event fires when deposit limit were changed.
 * @memberOf Playtech.API.events
 * @event deposit-limit-change
 * @type {callback}
 * @param {Object[]} details
 * @param {object[]} details.currentLimits
 * @param {object[]} details.waitingLimits
 * @param {string[]} details.allowedLimits
 * @param {object[]} details.limits
 * @param {string} details.lastIncreaseOverDefaultDate
 * @example Playtech.on('deposit-limit-change', ({ currentLimits, waitingLimits, allowedLimits, limits }) => { ... });
 */
export const DEPOSIT_LIMIT_CHANGE = 'deposit-limit-change';

export const useOnDepositLimitChange = (eventTarget: EventTarget) => {
    const trackDepositLimitChange = useCallback((detail: IGetDepositLimitsResponseData | ISetDepositLimitsRequestData) => {

        const event = new CustomEvent(DEPOSIT_LIMIT_CHANGE, {
            detail
        });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('deposit-limit-change', trackDepositLimitChange);

        return () => {
            publicEventsAPIService.off('deposit-limit-change', trackDepositLimitChange);
        };
    }, [trackDepositLimitChange]);
};
